import React from "react";
import AIModuleSubtopic from "../AIModuleSubtopic";

const AIEvolutionStateOfArtTypes = () => (
  <AIModuleSubtopic
    title="Introduction- Evolution of AI, State of Art - Types of AI"
    videos={[
      "https://www.youtube.com/embed/kmeaG_BQZ7M",
      "https://www.youtube.com/embed/A_JuGeeXRjw",
      "https://www.youtube.com/embed/Yybny8Jk3qU",
      "https://www.youtube.com/embed/wiscimXGqxg"
    ]}
    takeaways={[
      { text: "Understand the evolution and key milestones in AI development." },
      { text: "Learn about the current state-of-the-art in AI technologies." },
      { text: "Recognize the main types and classifications of AI." }
    ]}
    questions={[
      {
        text: "Describe different approaches to Artificial Intelligence. List the timeline of the evolution of artificial intelligence and briefly describe each period/breakthrough."
      },
      {
        text: "Explain in detail about any 10 applications of AI."
      },
      {
        text: "\"AI cannot replace Humans\" is the statement true? Justify your answer. Specify few crucial fields in which Human Touch is required."
      },
      {
        text: "Identify the following personalities and write about their contribution to Artificial Intelligence",
        image: "/ai_1.png"
      },
      {
        text: "Give the classification of approaches to AI based on its definitions. Describe how the Turing test provides the major disciplines that AI comprises of. Discuss the importance of the disciplines."
      },
      {
        text: "Explain the classifications of AI based on functionality and technology. Provide examples for each type"
      },
      {
        text: "Explain the key distinctions between the different types of Artificial Intelligence (AI) and provide real-world examples of each type."
      }
    ]}
    exampleVideos={[]}
  />
);

export default AIEvolutionStateOfArtTypes;
